import { serverNow } from '@/lib/serverClock';

export type BingoLetter = 'B' | 'I' | 'N' | 'G' | 'O';

const LETTER_RANGES: Array<{ letter: BingoLetter; min: number; max: number }> = [
    { letter: 'B', min: 1, max: 15 },
    { letter: 'I', min: 16, max: 30 },
    { letter: 'N', min: 31, max: 45 },
    { letter: 'G', min: 46, max: 60 },
    { letter: 'O', min: 61, max: 75 },
];

export function letterForNumber(n: number): BingoLetter | null {
    for (const r of LETTER_RANGES) {
        if (n >= r.min && n <= r.max) return r.letter;
    }
    return null;
}

export function ballLabel(n: number): string {
    const letter = letterForNumber(n);
    return letter ? `${letter}-${n}` : String(n);
}

export function countdownSeconds(iso: string | null | undefined, now = serverNow()): number | null {
    if (!iso) return null;
    const ms = new Date(iso).getTime() - now;
    if (Number.isNaN(ms)) return null;
    if (ms <= 0) return 0;
    return Math.ceil(ms / 1000);
}

export function gameStatusLine(
    status: string | undefined,
    countdownEndsAt: string | null | undefined,
    now = serverNow(),
): string {
    const secs = countdownSeconds(countdownEndsAt, now);
    if (status === 'active' || status === 'paused') return 'Game running';
    if (status === 'open' && secs !== null && secs > 0) return `Starting game in ${secs} sec`;
    if (status === 'open' && secs === 0) return 'Starting game…';
    if (status === 'completed') return 'Game complete';
    return 'Waiting for players';
}

/** Master board columns: B=1-15, I=16-30, … */
export function masterBoardColumns(): Record<BingoLetter, number[]> {
    return {
        B: Array.from({ length: 15 }, (_, i) => i + 1),
        I: Array.from({ length: 15 }, (_, i) => i + 16),
        N: Array.from({ length: 15 }, (_, i) => i + 31),
        G: Array.from({ length: 15 }, (_, i) => i + 46),
        O: Array.from({ length: 15 }, (_, i) => i + 61),
    };
}
